import React, { Component } from 'react';
import { Divider, Hidden, IconButton, List, ListItem, ListItemIcon, ListItemText, Fab } from "@material-ui/core";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { ALL_APPS, MODULE_CONTACT_US } from '../redux/authorizedApps/authorizedAppsConstants';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import Typography from "@material-ui/core/Typography";
import logo from "../images/Logo.png";
import { version } from "../../package.json";
import ProfileIcon from "@material-ui/icons/AccountBox";
import { GoogleLogout } from "react-google-login";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { withStyles } from "@material-ui/core/styles";
import { authorizedAppsFetchData } from '../redux/authorizedApps/authorizedAppsActions';
import { clearUsers } from '../redux/users/usersActions';

const styles = {
    menuButton: {
        '&:hover': {
            backgroundColor: "rgba(0, 0, 0, 0.25)"
        },
    },
    selectedMenuItem: {
        backgroundColor: "rgba(0, 0, 0, 0.25)",
    }
}

class SideBarContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            auth: this.props.activeUser !== null,
        }
    }

    componentDidMount() {
        this.props.fetchData(this.props.activeUser);
    }

    goTo(e, localeUrl) {
        this.props.history.push(localeUrl);
        e.stopPropagation();
    }

    logout() {
        this.props.clearUsers();
        this.props.history.push("/Login");
    }

    synchronization() {

    }

    onLogoClick() {
        this.props.history.replace("/");
    }

    render() {
        const { classes } = this.props;
        let apps = [];

        this.props.authorizedApps.forEach((authorizedApp) => {
            let matchingApps = ALL_APPS.filter((app) => app.code === authorizedApp.code);

            if (matchingApps.length <= 0 || matchingApps.length > 1)
                return;

            apps.push(matchingApps[0]);
        })

        apps.push(ALL_APPS.find(a => a.code === MODULE_CONTACT_US));

        return (
            <div className="full-height side-bar side-bar-background">
                {!this.props.permanent ? (
                    <div className={"side-bar-back"}>
                        <IconButton style={{
                            color: '#F5F5F6',
                        }} onClick={this.props.closeSideMenu}>
                            <ChevronLeftIcon />
                        </IconButton>
                    </div>
                ) : null}
                <div className={"side-bar-top-content"}>
                    <a href="/">
                        <div className="side-bar-appli-logo">
                            <img src={logo} alt="logo" style={{ width: "230px", backgroundColor: "#F5F5F6" }} />
                        </div>
                    </a>
                    <Hidden only={['xl', 'lg', 'md']}>
                        <div className="profile-menu">
                            <ListItemIcon className="user-icon" style={{ color: "#001A70" }}>
                                <ProfileIcon style={{ fontSize: 48 }} />
                            </ListItemIcon>
                            <GoogleLogout
                                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                                onLogoutSuccess={this.logout.bind(this)}
                                className="btn-logout logout-fab-btn"
                                icon={false}
                                buttonText="Déconnexion"
                                type="div"
                                tag="div"
                            >
                                <Fab size="small" style={{ color: "#F44336" }} >
                                    <FontAwesomeIcon title="Déconnexion" style={{ color: "#F44336" }} icon={faSignOutAlt} className="fa-lg" />
                                </Fab>
                            </GoogleLogout>
                            <Typography variant="body1" className="user-name">
                                {this.props.activeUser !== undefined
                                    ? this.props.activeUser.name_related
                                    : ""}
                            </Typography>
                        </div>
                    </Hidden>
                </div>
                <Divider className="white-divider" />
                <List className={"side-bar side-bar-body"}>
                    {apps.map((app) => (
                        <ListItem button key={app.name} classes={{
                            selected: classes.selectedMenuItem,
                        }} className={classes.menuButton} onClick={(e) => this.goTo(e, app.url)}
                            selected={this.props.history.location.pathname.startsWith(app.url)}>
                            <ListItemIcon>{app.icon}</ListItemIcon>
                            <ListItemText disableTypography primary={
                                <Typography type="body1" style={{ color: '#FFFFFF' }}>
                                    {app.name}
                                </Typography>
                            } />
                        </ListItem>
                    ))}
                </List>

                <div className={"side-bar-bottom-content col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding"}>
                    {this.props.children}
                    {/* <ListItem button onClick={this.synchronization.bind(this)} className={classes.menuButton}>
                        <ListItemIcon>
                            <SyncIcon style={{
                                fontSize: 32,
                                display: "block",
                                width: "32px",
                                height: "32px",
                                color: "#F5F6F5"
                            }} />
                        </ListItemIcon>
                        <ListItemText disableTypography primary={
                            <Typography type="body1" style={{ color: '#FFFFFF' }}>
                                Synchroniser
                            </Typography>
                        } />
                    </ListItem> */}
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 side-bar-version-margin-top">
                        <Divider className="white-divider" />
                        <Typography
                            style={{
                                color: "#F5F6F5",
                                fontSize: 10,
                                height: "20px",
                                width: "100%",
                                textAlign: "right",
                                paddingRight: "5px"
                            }}
                        >
                            Version {version}
                        </Typography>
                    </div>
                </div>
            </div >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        authorizedApps: state.authorizedApps,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: (user) => dispatch(authorizedAppsFetchData(user)),
		clearUsers: () => dispatch(clearUsers()),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(SideBarContent);
